/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './AllCurves.scss';
import { Flex } from '@vaisala-rockhopper/components';
import CurveCard from '../../cards/CurveCard';
import { CurveData } from '../../../../../modules/ChemicalDataController';

// interface AllCurvesProps {
//   curves: Array<CurveData>
//   onChemicalChanged(id: number): void
// }

const AllCurves = ({...props}) => {

  return (
    <div className="all-curves">
        <Flex
            alignContent="stretch"
            justifyContent="flex-start"
            flexDirection="column"
            flexWrap="nowrap"
            alignItems="stretch"
        >
          {props.curves.map((val: CurveData, i: number) => {
            return (
              <CurveCard
                key={i}
                cardData={val}
                onChemicalChanged={props.onChemicalChanged}
              />
            );
          })}
        </Flex>
    </div>
  );
};
export default AllCurves;
